<div class="preview-wrapper" *ngIf="createPaymentResponse">
  <section class="preview-section">
    <div class="preview-container">
      <ng-container *ngIf="!isLoading; else processingState">
        <div class="preview-content">
          <div class="header">
            <span class="header-title">{{ 'CHECKOUT.PREVIEW.HEADER_TITLE' | translate }}</span>
          </div>
          <div class="details-section">
            <ps-card [dynamic]="false" class="ps-card section-card"
                     [cardDensity]="PsCardDisplayDensity.Compact" [border]="PsCardBorder.None">
              <ps-card-content>
                <div class="section-body">
                  <div class="section-icon" aria-hidden="true">
                    <img class="section-icon-image"
                         src="assets/illustrations/merchant-icon.svg"
                         alt="" />
                  </div>
                  <div class="section-main">
                    <h2 class="section-title">{{ 'CHECKOUT.PREVIEW.ORDER_DETAILS_TITLE' | translate }}</h2>
                    <div class="details-content">
                      <div class="details-block">
                        <span class="item-key">{{ 'CHECKOUT.PREVIEW.MERCHANT_LABEL' | translate }}</span>
                        <span class="details-value">{{ createPaymentResponse?.payment.merchantName }}</span>
                      </div>
                      <div class="details-block">
                        <span class="item-key">{{ 'CHECKOUT.PREVIEW.ORDER_ID_LABEL' | translate }}</span>
                        <div class="order-id-line">
                          <span class="details-value order-id-value">{{ createPaymentResponse?.merchantRefNum }}</span>
                          <button type="button"
                                  class="copy-btn"
                                  [attr.aria-label]="'CHECKOUT.PREVIEW.COPY_ORDER_ID_A11Y' | translate"
                                  (click)="onCopyOrderId()">
                            <img class="copy-icon"
                                 src="assets/illustrations/copy-order-icon.svg"
                                 alt="" />
                          </button>
                          <span *ngIf="isOrderIdCopied" class="copied-hint" aria-live="polite">Copied</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ps-card-content>
            </ps-card>

            <ps-card [dynamic]="false" class="ps-card section-card"
                     [cardDensity]="PsCardDisplayDensity.Compact" [border]="PsCardBorder.None">
              <ps-card-content>
                <div class="section-body">
                  <div class="section-icon" aria-hidden="true">
                    <img class="section-icon-image"
                         src="assets/illustrations/order-summary-icon.svg"
                         alt="" />
                  </div>
                  <div class="section-main">
                    <h2 class="section-title">{{ 'CHECKOUT.PREVIEW.ORDER_SUMMARY_TITLE' | translate }}</h2>
                    <ps-list [hideBorders]="true" [displayDensity]="'stretched'" [isStatic]="true">
                      <ps-list-item>
                        <ps-list-item-title>
                          <span [class]="hasSufficientBalance ? 'item-key' : 'item-key warn'">
                            {{ 'CHECKOUT.PREVIEW.WALLET_BALANCE_LABEL' | translate }}
                          </span>
                        </ps-list-item-title>
                        <ps-list-item-suffix>
                          <span [class]="hasSufficientBalance ? 'item-value' : 'item-value warn'">
                            {{ formatCurrencyAmount(currentBalanceAmount, createPaymentResponse?.currencyCode) }}
                          </span>
                        </ps-list-item-suffix>
                      </ps-list-item>
                      <ps-list-item>
                        <ps-list-item-title>
                          <span class="item-key">{{ 'CHECKOUT.PREVIEW.ORDER_TOTAL_LABEL' | translate }}</span>
                        </ps-list-item-title>
                        <ps-list-item-suffix>
                          <span class="item-value">{{ formatCurrencyAmount(createPaymentResponse?.amount, createPaymentResponse?.currencyCode) }}</span>
                        </ps-list-item-suffix>
                      </ps-list-item>
                      <ps-list-item>
                        <ps-list-item-title>
                          <span class="item-key">{{ 'CHECKOUT.PREVIEW.FEE_LABEL' | translate }}</span>
                        </ps-list-item-title>
                        <ps-list-item-suffix>
                          <span class="item-value">{{ formatCurrencyAmount(feeAmount, createPaymentResponse?.currencyCode) }}</span>
                        </ps-list-item-suffix>
                      </ps-list-item>
                      <ps-list-item>
                        <ps-list-item-title>
                          <span [class]="hasSufficientBalance ? 'total-amount' : 'total-amount warn'">{{ 'CHECKOUT.PREVIEW.TOTAL_AMOUNT_LABEL' | translate }}</span>
                        </ps-list-item-title>
                        <ps-list-item-suffix>
                          <div class="total-suffix">
                            <span [class]="hasSufficientBalance ? 'total-amount-value' : 'total-amount-value warn'">
                              {{ formatCurrencyAmount(totalAmount, createPaymentResponse?.currencyCode) }}
                            </span>
                            <span *ngIf="!hasSufficientBalance" class="insufficient-funds">
                              {{ 'CHECKOUT.ERROR.INSUFFICIENT_FUNDS.TITLE' | translate }}
                            </span>
                          </div>
                        </ps-list-item-suffix>
                      </ps-list-item>
                    </ps-list>
                  </div>
                </div>
              </ps-card-content>
            </ps-card>
          </div>
        </div>
        <div class="actions">
          <button ps-primary-button (click)="onConfirm()" [disabled]="!hasSufficientBalance || isLoading || isCancelling || isPolling">
            <span class="button-text primary-button-text">{{ 'CHECKOUT.PREVIEW.CONFIRM_BUTTON' | translate }}</span>
          </button>
          <button ps-secondary-button (click)="onCancel()" [disabled]="isLoading || isCancelling || isPolling">
            <span class="button-text secondary-button-text">{{ 'CHECKOUT.PREVIEW.CANCEL_BUTTON' | translate }}</span>
          </button>
        </div>
      </ng-container>

      <ng-template #processingState>
        <section class="processing-state" aria-live="polite" aria-atomic="true">
          <ps-progress-spinner class="processing-spinner" strokeWidth="16" diameter="173" aria-hidden="true">
          </ps-progress-spinner>
          <h2 class="processing-title">{{ 'CHECKOUT.PREVIEW.PROCESSING_TITLE' | translate }}</h2>
          <p class="processing-subtitle">{{ 'CHECKOUT.PREVIEW.PROCESSING_SUBTITLE' | translate }}</p>
        </section>
      </ng-template>
    </div>
  </section>
</div>
<app-sca-modal *ngIf="scaDetails"
               [scaDetails]="scaDetails"
               (verified)="onScaVerified()"
               (error)="onScaError()"
               (close)="onScaClosed()">
</app-sca-modal>
